import { CircleCheck } from 'lucide-react'
import { useTranslation } from 'react-i18next'

const AllRentsPaid = () => {
  const { t } = useTranslation('contract')
  return (
    <div className="flex flex-col items-center justify-center gap-4 rounded-3xl border border-dashed border-primary/30 bg-primary/[0.04] px-6 py-14 text-center">
      <span className="flex h-14 w-14 items-center justify-center rounded-full bg-primary/10 text-primary">
        <CircleCheck className="h-7 w-7" />
      </span>
      <p className="m-0 font-display text-lg font-bold text-ink">
        {t('rent_table.rents.no_actual_payments')}
      </p>
    </div>
  )
}

export default AllRentsPaid
